import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

const COOKIE_BANNER_KEY = 'cookieBannerAck';

@Component({
  selector: 'app-cookie-banner',
  imports: [RouterLink],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
})
export class CookieBannerComponent {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  private readonly acknowledged = signal(this.readAcknowledged());

  readonly visible = computed(() => !this.acknowledged());

  readonly cookiePolicyLink = computed(() => {
    const path = this.currentUrl().split('?')[0].split('#')[0];
    return path === '/pagamenti' || path.startsWith('/pagamenti/')
      ? '/pagamenti/cookie'
      : '/cookie';
  });

  acknowledge(): void {
    try {
      localStorage.setItem(COOKIE_BANNER_KEY, '1');
    } catch {
      // ignore storage errors (private mode, quota, etc.)
    }
    this.acknowledged.set(true);
  }

  private readAcknowledged(): boolean {
    try {
      return localStorage.getItem(COOKIE_BANNER_KEY) === '1';
    } catch {
      return false;
    }
  }
}
